import { render, staticRenderFns } from "./PrepProgressHeader.vue?vue&type=template&id=36277e03&"
import script from "./PrepProgressHeader.vue?vue&type=script&lang=ts&"
export * from "./PrepProgressHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports